exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lesson-chat-history-list[data-v-64d73b20]{max-height:60vh;overflow-y:auto;padding:.25rem}.lesson-chat-history-item[data-v-64d73b20]{margin-bottom:.75rem;padding:.5rem .65rem;border-radius:8px;background:#f1f5f9}.lesson-chat-history-item--mine[data-v-64d73b20]{background:#e0f2fe}.lesson-chat-history-body[data-v-64d73b20] img{max-width:100%;height:auto}", ""]);

// exports
